<template lang="pug">
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
    },
    icon: {
      type: String,
      default: '',
    },
    color: {
      type: String,
      default: 'primary',
    },
    iconColor: {
      type: String,
      default: 'primary',
    },
    iconRight: {
      type: Boolean,
    },
    block: {
      type: Boolean,
    },
    type: {
      type: String,
      default: 'button',
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onClick() {
      this.$emit('click');
    },
  },
};
</script>

<style>
  .v-btn {
    border-radius: 4px;
    padding: 0 14px !important;
  }
  .btn--text {
    font-weight: bold;
    font-size: 14px;
    letter-spacing: 0.8px;
  }
</style>
